import { ERROR_MESSAGES } from "../app/shared/constants/error-messages.constant";

export function mapErrorMessage(rawMessage: string): string {
  if (!rawMessage) {
    return 'Une erreur est survenue';
  }

  const matchedKeys = Object.keys(ERROR_MESSAGES).filter((key) =>
    rawMessage.includes(key)
  );

  if (matchedKeys.length === 0) {
    return rawMessage;
  }

  if (matchedKeys.length > 1) {
    let result = rawMessage;
    for (const key of matchedKeys) {
      result = result.split(key).join(ERROR_MESSAGES[key]);
    }
    return result;
  }

  let friendly = ERROR_MESSAGES[matchedKeys[0]];

  const quotedMatch = rawMessage.match(/'([^']+)'/);
  if (quotedMatch && quotedMatch[1]) {
    friendly += ` (${quotedMatch[1]})`;
    return friendly;
  }

  const colonMatch = rawMessage.match(/:\s*([^\s,}]+)/);
  if (colonMatch && colonMatch[1]) {
    friendly += ` (${colonMatch[1]})`;
  }

  return friendly;
}